import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useGetContactInfo } from "@features/ux/components/recipientList/hooks";
import { Card } from "@shared/ui/card";
import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import { Info, Mail, MessageSquare, Phone, UserX, Users } from "lucide-react";
import React from "react";


const ContactOverviewDashboard = ({ data }: { data: any }) => {
  console.log(data);
  const { data: contactInfo } = useGetContactInfo(data?.result?.recipientList);
  const statsData = [
    {
      title: "Total",
      count: contactInfo?.total,
      icon: <Users className="h-5 w-5 text-blue-600" />,
      tooltipText: "Total number of users in this recipient list",
    },
    {
      title: "Email Only",
      count: contactInfo?.emailOnly,
      icon: <Mail className="h-5 w-5 text-purple-600" />,
      tooltipText: "Users with only email contact information",
    },
    {
      title: "Text Only",
      count: contactInfo?.phoneOnly,
      icon: <Phone className="h-5 w-5 text-green-600" />,
      tooltipText: "Users with only phone contact information",
    },
    {
      title: "Both",
      count: contactInfo?.bothAvailable,
      icon: <MessageSquare className="h-5 w-5 text-indigo-600" />,
      tooltipText: "Users with both email and phone contact information",
    },
    {
      title: "No Contact",
      count: contactInfo?.noContact,
      icon: <UserX className="h-5 w-5 text-red-600" />,
      tooltipText: "Users without any contact information",
    },
  ];

  return (
    <Card className="p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Users className="h-5 w-5 text-blue-600" />
        <h3 className="text-sm font-semibold text-gray-800">
          Contact Overview
        </h3>
        <Tooltip>
          <TooltipTrigger>
            <Info className="h-3 w-3 text-gray-400" />
          </TooltipTrigger>
          <TooltipContent>
            <p className="max-w-xs">
              Breakdown of available contact methods for recipients in this list
            </p>
          </TooltipContent>
        </Tooltip>
      </div>

      <div className="grid grid-cols-5 gap-3">
        {statsData.map((stat, index) => (
          <QuickStatsCard
            key={index}
            title={stat.title}
            count={stat.count}
            icon={stat.icon}
            tooltip={stat.tooltipText}
          />
        ))}
      </div>
    </Card>
  );
};

export default ContactOverviewDashboard;
